export const UMP_AUTOFILL_TOKENS = [
  /@universitymedicalpartners\.org$/,
  /\+ump/,
];

export const JMMG_AUTOFILL_TOKENS = [/@johnmuirhealth\.com$/, /\+jmmg/];
